import {NgModule} from '@angular/core';
import {EnumValPipe} from './enum-val.pipe';
import {HyphenPipe} from './hyphen.pipe';
import {MomentTZDatePipe} from './moment-tzdate.pipe';
import {PrettyIDPipe} from './pretty-id.pipe';
import {RemoveSpacePipe} from './remove-space.pipe';
import {ShortTimePipe} from './short-time.pipe';
import {SpacerPipe} from './spacer.pipe';

@NgModule({
  declarations: [EnumValPipe, HyphenPipe, MomentTZDatePipe, PrettyIDPipe, RemoveSpacePipe, ShortTimePipe, SpacerPipe],
  exports: [EnumValPipe, HyphenPipe, MomentTZDatePipe, PrettyIDPipe, RemoveSpacePipe, ShortTimePipe, SpacerPipe],
})
export class PipeModule {}



// WEBPACK FOOTER //
// ./src/app/shared/pipe/pipe.module.ts